import Modal from './Modal';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import {CleanUrl} from "../../../utils/cleanUrl";

const ModalReceiptUpload = (props) => {
    const { handleModal, promotionSettings } = props;
    const { t } = useTranslation();
    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);

    const config = {
        ADD_ATTR: ['target']
    };

    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        if (node.tagName.toLowerCase() === 'a') {
            node.setAttribute('target', '_blank');
        }
    });

    const sanitizedLegal = DOMPurify.sanitize(promotionSettings.promotion_type.where_to_find_code_text, config);

    return (
        <Modal>
            <div className="pweu-modal-overlay">
                <div className="pweu-modal pweu-modal--pack-code">
                    <div className="pweu-close-modal" onClick={handleModal}>
                        <img src={imagePath + "delete--white.svg"} alt="" />
                    </div>
                    <div className="pweu-modal-content">
                        {/* <h2 className='heading5'>{t("Depending on the product purchased you can find the code in different places.")}</h2> */}
                        <div dangerouslySetInnerHTML={{ __html: sanitizedLegal }}></div>
                        {/* <Splide className="pack-code-carousel" aria-label="" options={{arrows: false, perPage: 3, center: true, breakpoints: { 640: { perPage: 1 } }}}>
                            {content.map((item, i) => (
                                <SplideSlide key={i}>
                                    <img src={item.img} />
                                    <p>{item.text}</p>
                                </SplideSlide>
                            ))}
                        </Splide> */}
                        <img src={promotionSettings.promotion_type.example_pack_code} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalReceiptUpload;
